import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

import CustomMuiLink from 'common/components/custom-mui-link/CustomMuiLink';

const AuthActions = () => {
  return (
    <Box display="flex" gridColumnGap={12}>
      <CustomMuiLink href="/accounts/login">
        <Button variant="outlined" color="primary">
          Login
        </Button>
      </CustomMuiLink>
      <CustomMuiLink href="/accounts/signup">
        <Button variant="contained" color="primary">
          Join For Free
        </Button>
      </CustomMuiLink>
    </Box>
  );
};

export default AuthActions;
